import en from '@/languages/en.js'
import hr from '@/languages/hr.js'
import sl from '@/languages/sl.js'

export default class Languages {
  static translations = {
    en: en.translations,
    hr: hr.translations,
    sl: sl.translations,
  }
}
